import { gql } from '@apollo/client';

const TIMELINE_DATA = gql`
  query getTimeline($input: ProjectTimelineInput) {
    getProjectTimeline(input: $input) {
      data
      idealTime
    }
  }
`;

export default TIMELINE_DATA;
